import React, { Component } from "react";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import DataTable from 'react-data-table-component';
import { PrestamoCuota } from "./PrestamoCuota";
import MensajeUsuario from "../../generico/MensajeUsuario";
import PrestamoService from "../../../services/pagos/PrestamoService"
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import $ from "jquery";
import authService from "../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import { obtenerDatosOficialCuenta } from "../../../services/administracion/OficialCuentaService";


export default class PrestamoPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

  }

  getInitialState = () => ({
    listaPrestamo: [],
    prestamoSelected: [],
    disabledNext: true,
    datosOficialCuenta: null
  })


  componentDidMount() {
    this.cargarResumen()
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  cargarResumen = () => {

    var resumen = [];

    trackPromise(
      PrestamoService.resumenPrestamos()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);


          if (jsonData.codRespuesta === "0") {
            for (var i = 0; i < jsonData.detalles.length; i++) {
              resumen.push({
                id: jsonData.detalles[i].cuenta,
                tipo:(jsonData.detalles[i].numeroDestino!==86)?jsonData.detalles[i].descripcion:'Préstamo Digital',
                saldo: formatoSeparadorMilesValue(jsonData.detalles[i].saldoCapital),
                capital: formatoSeparadorMilesValue(jsonData.detalles[i].capital),
                moneda: jsonData.detalles[i].moneda,
                alDia: jsonData.detalles[i].alDia
              });
            }

            this.setState({ listaPrestamo: resumen });
          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.codDescripcion));
            return;
          }
        }
        ).catch(function (error) {
          //authService.logout()
          console.log(error)
        }));

    trackPromise(
      obtenerDatosOficialCuenta().then(({ data }) => {
        if (data.codigo === 0) {
          let datosOficialCuenta = data.datos;
          datosOficialCuenta.email = datosOficialCuenta.email && datosOficialCuenta.email.toLowerCase();
          this.setState({ datosOficialCuenta });
        }
      })
    )

    return resumen;
  }


  getColumn() {
    return [
      {

        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "100px",
      },
      {
        name: "Prestamo",
        selector: row => row.id,
      },
      {
        name: "Tipo de Crédito",
        selector: row => row.tipo,
      },
      {
        name: "Saldo",
        selector: row => row.selector,
      },
      
    ];
  }

  selGrupoEvt = (e) => {
    /*this.preSele = e.currentTarget;
    this.setState({ disabledNext: false });
    this.props.rptPaso1(this.preSele.id);
    this.enableNext();*/
    this.preSele = e.currentTarget;
    this.setState({ disabledNext: false });
    //this.props.rptPaso1(this.preSele.id);
    //this.enableNext();

    for (var i = 0; i < this.state.listaPrestamo.length; i++) {
      var ah = this.state.listaPrestamo[i]
      var ah_id = "radio_" + ah.id;
      if (ah_id === this.preSele.id) {
        this.props.rptPaso1(
          this.preSele.id,
          ah.tipo,
          ah.id,
          ah.capital,
          ah.moneda,
          ah.alDia
        );
      }
    }

    this.enableNext();
  };

  enableNext() {
    this.checkGrilla();
  }

  checkGrilla() {
    if (this.preSele !== undefined) {
      $("#" + this.preSele.id).prop("checked", true);
    }

  }

  seleccionarFila(row) {
    var radio = document.getElementById("radio_" + row.id)
    radio.click(this.selGrupoEvt);
  }



  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Préstamo
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Datos de Pago
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12" id="prestamo-pagos">
            <label className="input-label-bold">Seleccione el Prestamo que desea pagar *</label>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={this.getColumn()}
              data={this.state.listaPrestamo}
              dense={true}
              pagination={false}
              noDataComponent="no hay registros para mostrar"
              responsive={true}
              pointerOnHover
              onRowClicked={(e) => this.seleccionarFila(e)}
              expandableRows
              expandableRowsComponent={PrestamoCuota}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-12">
            <MensajeUsuario tipo="INFO"
              titulo="Importante."
              mensaje="Cuando el socio abone más de una cuota en forma adelantada, antes o en fecha del vencimiento, 
                          abonará una cuota normal y las restantes solamente el importe correspondiente a la amortización del capital." 

              mensaje2="El pago de la subsiguiente cuota deberá ser realizado indefectiblemente en el día del vencimiento mensual habitual del crédito,
                          disponiendo el socio de cinco días corridos para abonar una cuota normal. A partir del sexto día, la Cooperativa cobrará
                          los intereses de la cuotas abonadas por adelantado que fueron exonerados, sin perjuicio de los intereses moratorios, punitorios
                          y demás penalidades previstas en el presente manual."/>
          </div>
        </div>
        <br/>
        {this.state.datosOficialCuenta &&
          <div className="col-12 my-1">
            <div className="row p-2 text-dark agendar-box">
                <div className="col-12">
                  <h6>Oficial de Cuentas</h6>
                </div>
                <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                  <p className="m-0 text-left oficial"><span><b>Nombre:</b> </span>{this.state.datosOficialCuenta.nombreCompleto}</p>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                  <p className="m-0 text-left oficial"><span><b>Teléfono: </b></span> {this.state.datosOficialCuenta.celular}</p>
                </div>
                <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                  <p className="m-0 text-left oficial"><span><b>E-mail: </b></span> {this.state.datosOficialCuenta.email}</p>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                  <p className="m-0 text-left oficial"><span><b>Sucursal: </b></span> {this.state.datosOficialCuenta.sucursal}</p>
                </div>
            </div>
          </div>
        }
        <hr />
        <div className="row">
          <div className="col-lg-10 col-md-9">
              <label
                className="input-label-bold-obligatorio float-left">
                (*) Campos Obligatorios
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3">
              <button
                id="btn-next-paso" disabled={this.state.disabledNext}
                className="btn btn-cu-primary"
                onClick={this.props.paso1Next}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
          </div>
        </div>


      </div>
    );
  }
}